<template>
    <div>
        <div class="top">
            <div class="top-header">
            </div>

            <div class="container" v-if="orderInfo">
                <div class="header">
                    <h3>{{orderInfo.companyName}}</h3>
                    <p>{{orderInfo.companyBatchName}}</p>
                </div>

                <div class="card employee-wrapper">
                    <div class="emp-top">
                        <span class="emp-name">{{orderInfo.name}}</span><span
                            class="emp-mobile">{{orderInfo.mobile|mask("phone")}}</span>
                    </div>
                    <div class="info-cell">
                        <div class="cell-text">证件号码</div>
                        <div class="cell-value">{{orderInfo.idcard|mask("idcard")}}</div>
                    </div>
                    <div class="info-cell">
                        <div class="cell-text">体检编号</div>
                        <div class="cell-value">{{orderInfo.examNo}}</div>
                    </div>
                    <div class="info-cell">
                        <div class="cell-text">体检日期</div>
                        <div class="cell-value">{{orderInfo.appointDate}}</div>
                    </div>
                    <div class="info-cell">
                        <div class="cell-text">体检时间</div>
                        <div class="cell-value">{{orderInfo.appointTimeRangeName}}</div>
                    </div>
                    <div class="info-cell">
                        <div class="cell-text">套餐分组</div>
                        <div class="cell-value" @click="showGroupItems = true">{{orderInfo.groupName}}
                            <span style="float:right;color:#1496f1;">共{{groupItemsCount}}项
                                <van-icon name="arrow" /></span></div>
                    </div>
                </div>

                <div class="card add-item-card">
                    <p class="title">自选加项</p>
                    <ul>
                        <li class="item-wrapper" v-for="(combo,i) in orderInfo.addCombos">
                            <div class="combo-list">
                                <div class="combo-item">
                                    {{combo.comboName}}
                                </div>
                                <div class="combo-extra">
                                    <div class="combo-mean" v-if="combo.comboMeanning && combo.comboMeanning.length">
                                        {{combo.comboMeanning}}
                                    </div>
                                    <div class="combo-tag1"
                                        v-if="combo.comboImportantTips && combo.comboImportantTips.length">
                                        {{combo.comboImportantTips}}
                                    </div>
                                </div>
                            </div>

                        </li>
                    </ul>
                </div>

                <div class="buttons-wrap">
                    <van-button @click="backToList" size="large" type="info">返回列表</van-button>
                </div>
            </div>

            <!-- 显示分组明细项目 -->
            <van-popup v-model="showGroupItems" round position="bottom">
                <div class="group-items-wrapper">
                    <p class="group-items-header">套餐分组项目</p>
                    <div v-for="group in groupItems">
                        <div class="group-title">{{group.title}}</div>
                        <ul class="item-list">
                            <li v-for="(item,i) in group.items" class="item-detail">
                                <p class="item-name">{{item.itemName}}</p>
                                <p class="item-mean">{{item.itemMeanning}}</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </van-popup>
        </div>
    </div>
</template>

<style lang="less" scoped>
    .top {
        width: 100%;
        position: relative;
        z-index: 0;
        overflow: hidden;
        color: #ffffff;
    }

    .top::before {
        content: '';
        width: 120%;
        height: 160px;
        position: absolute;
        left: -10%; //椭圆左边隐藏10%，右边隐藏10%
        top: 0;
        border-radius: 0 0 50% 50%; //左上角，右上角，右下角，左下角
        background: #1496f1;
        z-index: -1;
    }

    .container {
        width: calc(100% - 20px);
        // min-height: 100vh;
        top: 0;
        left: 0;
        padding: 10px;
        padding-bottom: 60px;

        .header {
            color: #ffffff;

            h3 {
                line-height: 36px;
                font-size: 20px;
                font-weight: 600;
            }

            p {
                font-size: 14px;
            }
        }

        .card {
            margin-top: 16px;
            background: #ffffff;
            border-radius: 8px;
            color: rgba(0, 0, 0, 0.75);
            padding: 16px;
        }

        .employee-wrapper {
            .emp-top {
                margin-bottom: 10px;

                .emp-name {
                    font-size: 18px;

                }

                .emp-mobile {
                    margin-left: 16px;
                    font-size: 14px;
                    color: rgba(0, 0, 0, 0.45)
                }
            }


            .info-cell {
                display: flex;
                padding: 10px 0;
                font-size: 14px;

                .cell-text {
                    width: 100px;
                    color: rgba(0, 0, 0, 0.45);
                }

                .cell-value {
                    flex: 1;
                    cursor: pointer;
                }
            }
        }

        .add-item-card {
            .title {
                font-size: 16px;
                font-weight: 600;
            }

            .combo-list {
                padding-top: 12px;

                .combo-item {
                    flex: 1;
                    line-height: 24px;
                    font-size: 14px;

                    /deep/.van-checkbox__icon .van-icon {
                        line-height: 1em;
                    }

                    //font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
                }

                .combo-point {
                    font-size: 13px;
                }

                .van-button--small {
                    padding: 0 16px;
                }
            }

            .combo-extra {
                .combo-mean {
                    padding: 4px 0;
                    font-size: 13px;
                    color: rgba(0, 0, 0, 0.5);
                }

                .combo-tag1 {
                    background: rgb(255, 232, 210);
                    color: rgb(201, 74, 1);
                    font-size: 13px;
                    padding: 4px;
                    border-radius: 4px;
                }

                .combo-tag2 {
                    background: rgb(255, 232, 210);
                    color: rgb(201, 74, 1);
                }
            }
        }

        .buttons-wrap {
            margin-top: 16px;
            padding: 0 8px;
        }
    }

    .group-items-wrapper {
        height: 80vh;
        overflow: auto;
        padding: 0 16px;
        color: #2c3e50;

        .group-items-header {
            text-align: center;
            padding-top: 12px;
        }

        .group-title {
            font-size: 16px;
            font-weight: 600;
            padding: 16px 0 10px 0;
        }

        .item-list {
            padding: 0 16px;

            .item-detail {
                padding: 8px 0;
                border-bottom: 1px solid rgba(0, 0, 0, 0.05);

                .item-name {
                    font-size: 14px;
                    padding-bottom: 4px;
                }

                .item-mean {
                    font-size: 12px;
                    color: rgba(0, 0, 0, 0.45);
                }
            }
        }
    }
</style>

<script>
    import {
        updateAppointment,
        getSchedule,
        saveAppointment

    } from '@/api/company';
    import {
        async
    } from 'q';
    import moment from 'moment';
    export default {
        data() {
            return {
                orderInfo: undefined,
                showGroupItems: false,
                groupItems: [],
            }
        },
        computed: {
            hospId: function () {
                return this.$route.query.hospid;
            },
            groupItemsCount: function () {
                if (this.orderInfo && this.orderInfo.groupItems && this.groupItems.length) {
                    return this.orderInfo.groupItems.length;
                } else {
                    return 0;
                }
            }
        },
        methods: {
            backToList() {
                this.$router.replace("/company/orderlist");
            }
        },
        created() {
            let hospid = this.$route.query.hospid;
            var appt = JSON.parse(localStorage.getItem("companyAppointment"));
            if (appt == null) {
                this.$router.push('/');
                return;
            }
            this.orderInfo = appt;
            if (this.orderInfo.groupItems && this.orderInfo.groupItems.length > 0) {
                var items0 = this.orderInfo.groupItems.filter(it => {
                    return it.itemType == 0
                });
                if (items0.length > 0) {
                    this.groupItems.push({
                        title: "一般检查",
                        items: items0
                    })
                }
                var items1 = this.orderInfo.groupItems.filter(it => {
                    return it.itemType == 1
                });
                if (items1.length > 0) {
                    this.groupItems.push({
                        title: "影像及辅助检查",
                        items: items1
                    })
                }
                var items2 = this.orderInfo.groupItems.filter(it => {
                    return it.itemType == 2
                });
                if (items2.length > 0) {
                    this.groupItems.push({
                        title: "检验项目",
                        items: items2
                    })
                }
                var items3 = this.orderInfo.groupItems.filter(it => {
                    return it.itemType == 3
                });
                if (items3.length > 0) {
                    this.groupItems.push({
                        title: "其它项目",
                        items: items3
                    })
                }
            }
        }
    }
</script>